import { ExternalLink } from "lucide-react";

import { getToolDisplayInfo } from "../../toolConfig";
import { NavigationItem } from "../../stores";

import { ToolIcon } from "./ToolIcon";
import { ToolText } from "./ToolText";
import { useWorkspaceToolNavigation } from "./useWorkspaceToolNavigation";

import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/Tooltip";
import { cn } from "@/lib/utils";

export const ToolResultLinkRow = ({
  displayInfo,
  navigation,
}: {
  displayInfo: ReturnType<typeof getToolDisplayInfo>;
  navigation?: NavigationItem[];
}) => {
  const handleNavigate = useWorkspaceToolNavigation();
  const primaryNavigation = navigation?.[0];

  if (!primaryNavigation) {
    return null;
  }

  return (
    <TooltipProvider delayDuration={300}>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            type="button"
            onClick={() => handleNavigate(primaryNavigation.url, primaryNavigation.method)}
            className={cn(
              "group -ml-1 inline-flex w-fit max-w-full items-center gap-1.5 rounded-md px-1 py-0.5 text-left transition-colors hover:bg-gray-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-300",
            )}
          >
            <span className="flex h-4 w-4 items-center justify-center">
              <ToolIcon
                type={displayInfo.type}
                className="text-gray-400 transition-colors group-hover:text-gray-500"
              />
            </span>
            <ToolText className="min-w-0 truncate text-gray-500 transition-colors group-hover:text-gray-700">
              {displayInfo.displayName}
            </ToolText>
            <ExternalLink className="h-3 w-3 flex-shrink-0 text-gray-400 transition-colors group-hover:text-gray-600" />
          </button>
        </TooltipTrigger>
        <TooltipContent side="right" className="max-w-xs">
          <p>{primaryNavigation.reason}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
